import {db, storage} from '../../firebase/index';
import { push, replace } from 'connected-react-router'
import * as Functions from '../../commonFunc'
import {initialState} from "../Store/initialState";
import {transitionToHome} from "../Transition/actions";

export const postQuestion = (payload) => {
    return async (dispatch, getState) => {
        const currentState = getState();
        let addValue = payload;
        const newQuestionRef = db.collection('questions').doc();

        addValue['id'] = newQuestionRef.id;
        addValue["creator_id"] = currentState.user.userId;
        addValue["created_at"] = Functions.getDatetimeAsNumber();
        addValue['is_inappropriate'] = false;

        newQuestionRef.set(addValue).then(() => {
            dispatch(transitionToHome())
        }).catch(() => {
            alert('投稿に失敗しました。もう1度試してください。');
        });
    };
};

export const cancelPost = () => {
    return (dispatch) => {
        dispatch(push('/'));
        dispatch(backToHome())
    }
};

export const inputText = (key, value) => {
    return (dispatch) => {
        dispatch(updateValue(key, value))
    }
};

export const uploadImage = (id, event) => {
    return (dispatch, getState) => {
        const file = event.target.files;
        const file_name = file[0].name;
        const blob = new Blob(file, {type: "image/jpeg"});

        const uploadRef = storage.ref('image').child(file_name);
        const uploadTask = uploadRef.put(blob);
        uploadTask.on('state_changed', (snapshot) => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
        }, (error) => {
            // Handle unsuccessful uploads
            console.error("Failed to upload file. ERROR: ", error);
        }, () => {
            // Handle successful uploads on complete
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                console.log('File available at', downloadURL);
                document.getElementById(`${id}-thumb`).setAttribute('src', downloadURL);
                document.getElementById(id).setAttribute('data-name', file_name);
                dispatch(updateValue(id, downloadURL))
            });
        });
    }
};

export const deleteImage = (id) => {
    return (dispatch, getState) => {
        const fileName = document.getElementById(id).getAttribute('data-name');
        storage.ref('image').child(fileName).delete()
            .then(() => {
                document.getElementById(`${id}-thumb`).setAttribute('src', "https://firebasestorage.googleapis.com/v0/b/nitaku-dev-2d298.appspot.com/o/image%2Fno-image-1.jpg?alt=media&token=430fe67b-45f4-4f9a-9839-d980ff6c8c71")
                document.getElementById(id).setAttribute('data-name', "");
                dispatch(updateValue(id, ""))
            }).catch(error => {
            alert('画像ファイルの削除に失敗しました。');
            console.error(error)
        })
    }
};

// Action for setting initial value of the post state
export const RESET_VALUE = "RESET_VALUE";
export const resetPostState = () => {
    return {type: "RESET_VALUE", payload: initialState.post}
};

export const BACK_TO_HOME = "BACK_TO_HOME";
export const backToHome = () => {
    return {
        type: "BACK_TO_HOME",
        payload: initialState.post
    }
}

export const UPDATE_VALUE = "UPDATE_VALUE";
export const updateValue = (key, value) => {
    return {
        type: "UPDATE_VALUE",
        payload: {key, value}
    }
};
